import React from 'react'
import { Box, Typography } from '@mui/material'

export const Error403: React.FC = () => {
  return (<Box><Typography>Error 403</Typography></Box>)
}
